<template>
  <b-alert :show="computedShow" :variant="variant" @input="onInput">
    <slot />
  </b-alert>
</template>

<script>
/**
 * Инлайн-алерт для форм (логин, валидация у полей).
 * v-model — видимость. Для постоянно видимого блока задайте permanent.
 */
export default {
  name: 'AppInlineAlert',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    variant: {
      type: String,
      default: 'info'
    },
    permanent: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    computedShow: function () {
      if (this.permanent) {
        return true;
      }
      return this.value;
    }
  },
  methods: {
    onInput: function (v) {
      if (!this.permanent) {
        this.$emit('input', v);
      }
    }
  }
};
</script>
